"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    StarSolid: function() {
        return StarSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const StarSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.6071 1.78907C11.11 0.531868 12.8897 0.531906 13.3925 1.78914L15.6932 7.5413L21.8889 7.92852C23.209 8.01103 23.7839 9.63757 22.8089 10.5313L18.122 14.8277L19.6573 20.5851C20.0006 21.8724 18.6205 22.935 17.4637 22.274L11.9998 19.1517L6.5355 22.274C5.37877 22.935 3.99868 21.8724 4.34196 20.5852L5.8773 14.8277L1.1904 10.5313C0.215385 9.63757 0.790317 8.01103 2.11042 7.92852L8.30606 7.5413L10.6071 1.78907Z",
        fill: "currentColor"
    })
}), "StarSolid");
const _default = StarSolid;
